export const statusInvoiceOptions = [
  {
    id: 'paid',
    label: 'Paid',
  },
  {
    id: 'draft',
    label: 'Draft',
  },
  {
    id: 'open',
    label: 'Unpaid',
  },
]
